import ImgService from '../../../assets/images/img-service.png';
import IconCrab from '../../../assets/icons/ic-crab.svg';
import { useTranslation } from 'react-i18next';

const Service = () => {
  const { t } = useTranslation('header');
  return (
    <div id="service" className="relative">
      <div className="relative px-4 xl:px-[100px] mt-9 xl:mt-[100px]">
        <div className="xl:absolute xl:left-[100px] xl:top-0 bg-blue-50 xl:border-[24px] xl:border-white xl:w-[45%] p-4 xl:p-6">
          <h4 className="font-dancing-script text-orange-300 text-[16px] xl:text-[24px] font-bold">
            {t('service.titleMain')}
          </h4>
          <div>
            <h2 className="mt-2 text-primary text-base xl:text-xl font-bold xl:font-extrabold">
              {t('service.title1')}
            </h2>
            <p className="mt-4 text-grey-100 text-sm xl:text-base leading-5 xl:leading-[22px]">
              {t('service.describe1')}
            </p>
          </div>
          <div>
            <h2 className="mt-2 text-primary text-base xl:text-[20px] font-bold xl:font-extrabold">
              {t('service.title2')}
            </h2>
            <p className="mt-4 text-grey-100 text-[14px] xl:text-base leading-5 xl:leading-[22px]">
              {t('service.describe2')}
            </p>
          </div>
          <div>
            <h2 className="mt-2 text-primary text-base xl:text-[20px] font-bold xl:font-extrabold">
              {t('service.title3')}
            </h2>
            <p className="mt-4 text-grey-100 text-[14px] xl:text-base leading-5 xl:leading-[22px]">
              {t('service.describe3')}
            </p>
          </div>
        </div>

        <div className="xl:w-[66%] ml-auto pt-4 xl:pt-20">
          <img src={ImgService} alt="service" className="w-full" />
        </div>
      </div>

      <div className="absolute bottom-[-20%] xl:bottom-[-90%] right-[-32%] xl:right-[-16%] -z-10">
        <img src={IconCrab} alt="crab" className="w-[304px] xl:w-auto" />
      </div>
    </div>
  );
};

export default Service;
